import React, { useState } from 'react'
import { useEffect } from 'react'
import { useReceivement } from '../../../../../hooks/useReceivement'
import { getReceivementBatches } from '../../../../../services/receivement/receivementService'
import FinishButton from '../components/FinishButton'
import NewBatchForm from './components/NewBatchForm'
import TableProducts from './components/TableProducts'
import ModalTruckTemperature from './components/ModalTruckTemperature'
import { useDeleteModal } from './hooks/useDeleteModal'
import { useLabelPrinting } from '../../../../../hooks/useLabelPrinting'
import * as S from './NewBatch.styles'

export default function NewBatch({ tiposAvaria, receivementId }) {
  const { operatorBadge, operatorName } = useReceivement({
    valideOperator: true
  })
  const [tableData, setTableData] = useState()
  const [showTruckTemperatureModal, setShowTruckTemperatureModal] = useState(false)
  const { handleBatachDeleteOnClick, DeleteModalComponent } = useDeleteModal({
    setTableData,
    operatorBadge
  })
  const { showModalLabelPrinting, labelPrintingComponent } = useLabelPrinting({
    operatorName,
    onFinish: () => {}
  })

  const handleTruckTemperatureClose = () => {
    setShowTruckTemperatureModal(false)
  }

  useEffect(() => {
    if (tableData === undefined) {
      ;(async () => {
        const result = await getReceivementBatches(operatorBadge, receivementId)

        if(result.data.has_frozen_items){
          setShowTruckTemperatureModal(true)
        }

        if (result.isOk && !result.data.has_frozen_items) {
          setTableData(result.data)
          if (result.data.length > 0) {
            showModalLabelPrinting([result.data.at(-1)])
          }
        } else {
          setTableData([])
        }
      })()
    }
  }, [
    tableData,
    setTableData,
    receivementId,
    showModalLabelPrinting,
    operatorBadge
  ])

  if (tableData === undefined) {
    return <></>
  }

  return (
    <>
      <S.WrapperHeader>
        <S.Title>Recebimento</S.Title>
        <FinishButton
          disabled={tableData.length === 0}
          receivementId={receivementId}
        />
      </S.WrapperHeader>

      <S.WrapperNewBatch>
        <NewBatchForm
          tiposAvaria={tiposAvaria}
          receivementId={receivementId}
          setTableData={setTableData}
          operatorBadge={operatorBadge}
          operatorName={operatorName}
        />

        <S.HR />

        <TableProducts
          tableData={tableData}
          handleDeleteRow={handleBatachDeleteOnClick}
        />

        <DeleteModalComponent />
      </S.WrapperNewBatch>
      {labelPrintingComponent}
      
      <ModalTruckTemperature
        show={showTruckTemperatureModal}
        onClose={handleTruckTemperatureClose}
        receivementId={receivementId}
        operatorBadge={operatorBadge}
        testId="modal-truck-temperature-test-id"
      />
    </>
  )
}
